<template>
  <div>
    <v-card v-if="etapes.length > 0">
      <v-card-title>Etapes :</v-card-title>
      <v-card-text>
        <template>
          <v-list>
            <v-list-item v-for="(item, index) in etapes" :key="index">
              <v-list-item-content>
                <v-list-item-title
                  >{{ item.rang }} : {{ item.ll_etape }}
                </v-list-item-title>
                <DetailsEtape :etape="item" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </v-card-text>
    </v-card>

    <div v-else>
      Pas d'Etapes
    </div>
  </div>
</template>

<script>
export default {
  components: {
    DetailsEtape: require("@/components/organisation/detailsEtape").default,
  },
  created() {
    this.getEtapeData(this.activite.id);
  },
  props: {
    activite: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      etapes: [],
    };
  },
  methods: {
    getEtapeData(activiteId) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("etapes")
        .where("parcours_id_parcours", "==", activiteId.toString())
        .orderBy("rang")
        .get()
        .then((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              self.etapes.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "modified") {
              let obj = self.etapes.find(
                (search) => search.id === change.doc.id
              );

              //bailleurs
              /*  obj.name = change.doc.data().abbr_bailleur;
                            obj.title = change.doc.data().ll_bailleur;
                            obj.ll_bailleur = change.doc.data().ll_bailleur;
                            obj.abbr_bailleur = change.doc.data().abbr_bailleur; */
            }
            if (change.type === "removed") {
              /*   console.log("Removed : ", change.doc.data());
                            let obj = elems.find((search) => search.id === change.doc.id);
                            const index = elems.indexOf(obj);
                            Vue.delete(elems, index); */
              //deleteProjetsDeBailleurs
            }
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
